import {createClient} from '@sanity/client'

export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || 'brsqq1gn',
  dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || '2023-10-01',
  useCdn: process.env.REACT_APP_SANITY_USE_CDN === 'true',
})

